import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

// 1️⃣ Create the context
const AppContext = createContext();

// 2️⃣ Custom hook for easy access
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within AppProvider");
  }
  return context;
};

// 3️⃣ Provider component
export const AppProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [user, setUser] = useState(null);

  // logout function (customer)
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userEmail");

    setIsLogin(false);
    setUser(null);
  };
  //
  // const [baseUrl, setbaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFiles, setbaseUrlForFiles] = useState( "http://127.0.0.1:8000/storage");
  const [baseUrl, setbaseUrl] = useState("https://time4pulse.btsportfolio2026.com/backend/public/api",);
  const [baseUrlForFiles, setbaseUrlForFiles] = useState("https://time4pulse.btsportfolio2026.com/backend/public/storage",);
  const [cartItems, setCartItems] = useState([]);
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const addToDealBox = (deal) => {
    setCartItems((prev) => [...prev, deal]);
  };
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryTagline, setSelectedCategoryTagline] =
    useState("Health & Wellness");
  const [adminCategory, setAdminCategory] = useState("");

  // ── Rehydrate logged-in users from localStorage on load ──
  // Without this, refreshing or navigating directly to a page (without
  // going through the login screen) resets these to undefined, even
  // though the user is still logged in.
  const [loggedInAdmin, setLoggedInAdmin] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("loggedInAdmin")) || null;
    } catch {
      return null;
    }
  });
  const [loggedInSeller, setLoggedInSeller] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("loggedInSeller")) || null;
    } catch {
      return null;
    }
  });
  const [loggedInCustomer, setLoggedInCustomer] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("loggedInUser")) || null;
    } catch {
      return null;
    }
  });

  // ✅ NEW: logoutAdmin — token + admin state dono clear karta hai
  const logoutAdmin = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("loggedInAdmin");
    setLoggedInAdmin(null);
  };

  const [
    selectedScreenOfSellerDashboardSidebar,
    setSelectedScreenOfSellerDashboardSidebar,
  ] = useState("Dashboard");
  const [
    selectedScreenOfAdminDashboardSidebar,
    setSelectedScreenOfAdminDashboardSidebar,
  ] = useState("Dashboard");
  // User info

  // Cart
  const [cart, setCart] = useState([
    {
      id: 1,
      title: "Full Body Spa",
      price: 3000,
      quantity: 1,
      image: "https://via.placeholder.com/80",
    },
  ]);

  // Wishlist
  const [wishlist, setWishlist] = useState([
    {
      id: 2,
      title: "Hair Treatment",
      price: 1500,
      image: "https://via.placeholder.com/80",
    },
  ]);
  const addToCart = (item) => {
    setCart((prevCart) => [...prevCart, item]);
  };

  // UI helper functions
  const storeSelectedCategory = (sc) => setSelectedCategory(sc);
  const storeSelectedCategoryTagline = (sct) => setSelectedCategoryTagline(sct);

  //Admin UI Helper Function

  const storeAdminCategory = (sa) => setAdminCategory(sa);

  const storeSelectedScreenOfSellerDashboardSidebar = (scosds) =>
    setSelectedScreenOfSellerDashboardSidebar(scosds);
  const storeSelectedScreenOfAdminDashboardSidebar = (scoads) =>
    setSelectedScreenOfAdminDashboardSidebar(scoads);
  // Derived counts
  const cartCount = cart.length;
  const wishlistCount = wishlist.length;
  useEffect(() => {
    const savedCustomer = localStorage.getItem("loggedInUser");

    if (savedCustomer) {
      try {
        const customer = JSON.parse(savedCustomer);

        setLoggedInCustomer(customer);
        setUser(customer);
        setIsLogin(true);
      } catch (error) {
        console.log("Invalid loggedInUser:", error);

        localStorage.removeItem("loggedInUser");
        setLoggedInCustomer(null);
        setUser(null);
        setIsLogin(false);
      }
    }
  }, []);

  // ✅ UPDATED: Har role (admin / seller / customer) ka apna alag token hai,
  // isliye request ke URL pattern dekh kar sahi token attach kiya ja raha hai.
  // Pehle sirf "authToken" (seller/customer ka) har jagah bheja ja raha tha,
  // jisse admin routes galat token le kar 401 dete thay.
  useEffect(() => {
    const interceptorId = axios.interceptors.request.use((config) => {
      const url = config.url || "";

      if (url.includes("/admin/")) {
        const adminToken = localStorage.getItem("adminToken");
        if (adminToken) {
          config.headers.Authorization = `Bearer ${adminToken}`;
        }
      } else if (url.includes("/seller/") || url.includes("/tpshop/")) {
        const sellerToken = localStorage.getItem("sellerToken");
        if (sellerToken) {
          config.headers.Authorization = `Bearer ${sellerToken}`;
        }
      } else {
        // customer / default requests
        const token = localStorage.getItem("authToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }

      return config;
    });

    return () => {
      axios.interceptors.request.eject(interceptorId);
    };
  }, []);

  /////////////////////////////////validation//////////////////////////////////////
  // FIX: previously only allowed a single word of 5+ letters ("Ali" failed,
  // "Ali Raza" failed). Now allows one or more space-separated name words
  // (each letters-only), with the full trimmed name at least 3 characters.
  const fullNameRegTp = new RegExp(/^[A-Za-z]+(\s[A-Za-z]+)*$/);
  const emailRegTp = new RegExp(
    /^[A-Za-z0-9._%+-]{2,}@[a-z0-9]{2,}\.[a-z]{2,}$/,
  );
  const passwordRegTp =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%_!&.?])[A-Za-z\d@#$%_!&.?]{8,}$/;
  const phoneNumberRegTp = new RegExp(/^[0-9]{4,4}-[0-9]{7,7}$/);
  const messageRegTp = new RegExp(/^.{2,}$/);
  const categoryRegTp = new RegExp(/^.{2,}$/);
  const titleRegTp = /^[A-Za-z0-9\s]{5,100}$/;
  const keywordRegTp = /^[A-Za-z0-9,\s]{3,200}$/;
  const CNICRegTp = new RegExp(/^[0-9]{5,5}-[0-9]{7,7}-[0-9]{1,1}$/);
  const dealTitleRegTp = new RegExp(/^.{5,100}$/);
  const descriptionRegTp = new RegExp(/^.{10,500}$/);

  const regTpChecker = (type, input) => {
    switch (type) {
      case "fullName":
        if (
          !input ||
          input.trim().length < 3 ||
          !fullNameRegTp.test(input.trim())
        ) {
          return "Full name must be at least 3 characters long and contain only letters (spaces allowed, e.g. 'Ali Raza')";
        }
        break;
      case "email":
        if (!input || !input.trim()) {
          return "Email is required";
        }

        if (!emailRegTp.test(input.trim())) {
          return "Please enter a valid email address";
        }

        break;
      case "blogTitle":
        if (!titleRegTp.test(input)) {
          return "Title must be at least 5 characters long.";
        }
        break;

      case "blogDescription":
        if (!input || input.replace(/<[^>]*>/g, "").trim().length < 20) {
          return "Description must be at least 20 characters long.";
        }
        break;

      case "blogKeyword":
        if (!keywordRegTp.test(input)) {
          return "Please enter valid keywords.";
        }
        break;

      case "blogCategory":
        if (!input) {
          return "Please select a category.";
        }
        break;

      case "blogImage":
        if (!input) {
          return "Please select an image.";
        }
        break;
      case "message":
        if (!messageRegTp.test(input)) {
          return "Message must be at least 20 characters long";
        }
        break;
      case "category":
        if (!messageRegTp.test(input)) {
          return "Category must be at least 10 characters long";
        }
        break;
      case "password":
        console.log("Password:", input);

        if (!passwordRegTp.test(input.trim())) {
          return "Password must be at least 8 characters long and contain uppercase, lowercase, number and special character.";
        }

        break;

      case "faqQuestion":
        if (!input || input.trim().length < 10) {
          return "Question must be at least 10 characters long.";
        }
        break;

      case "faqAnswer":
        if (!input || input.trim().length < 20) {
          return "Answer must be at least 20 characters long.";
        }
        break;

      case "faqType":
        if (!input) {
          return "Please select user type.";
        }
        break;
      case "marqueeTitle":
        if (!input || input.trim().length < 15) {
          return "Title must be at least 15 characters long.";
        }
        break;
      case "faqQuestion":
        if (!input || input.trim().length < 10) {
          return "Question must be at least 10 characters long.";
        }
        break;

      case "faqAnswer":
        if (!input || input.trim().length < 15) {
          return "Answer must be at least 15 characters long.";
        }
        break;

      case "faqType":
        if (!input) {
          return "Please select FAQ type.";
        }
        break;

      // case "marqueeLink":
      //   if (input && !/^https?:\/\/.+|^\/.+/.test(input)) {
      //     return "Please enter a valid URL or path.";
      //   }
      //   break;
      case "phoneNumber":
        if (!phoneNumberRegTp.test(input)) {
          return "Phone Number must be in the format: 0300-1234567";
        }
        break;
      case "CNIC":
        if (!CNICRegTp.test(input)) {
          return "CNIC number must be in the format: 12345-1234567-1";
        }
        break;
      case "dealTitle":
        if (!input || !dealTitleRegTp.test(input)) {
          return "Deal title must be 5 to 100 characters long";
        }
        break;
      case "description":
        if (!input || !descriptionRegTp.test(input)) {
          return "Description must be at least 10 characters long";
        }
        break;
      case "discountPercentage":
        if (input === "" || input === null || isNaN(input)) {
          return "Discount percentage is required";
        }
        if (Number(input) < 0 || Number(input) > 100) {
          return "Discount must be between 0 and 100";
        }
        break;
      case "expiresAt":
        if (!input) {
          return "Please select deal expiry date & time";
        }
        if (new Date(input) <= new Date()) {
          return "Expiry date must be in the future";
        }
        break;
      // case "amount":
      //   if (input === "" || input === null || isNaN(input)) {
      //     return "Amount is required";
      //   }
      //   if (Number(input) <= 0) {
      //     return "Amount must be greater than 0";
      //   }
      //   break;
      case "accountHolderName":
        if (!input || input.trim().length < 3) {
          return "Enter a valid account holder name";
        }
        break;
      case "accountNumber":
        if (!input || input.trim().length < 5) {
          return "Enter a valid account/wallet number";
        }
        break;
      case "ticketTitle":
        if (!input || input.trim().length < 2) {
          return "Title must be at least 2 characters long";
        }
        break;
      case "ticketDescription":
        if (!input || input.trim().length < 10) {
          return "Description must be at least 10 characters long";
        }
        break;
      case "phoneSimple":
        if (!input || !/^[0-9]{10,11}$/.test(input)) {
          return "Phone number must be 10-11 digits";
        }
        break;
      case "shopName":
        if (!input || input.trim().length < 3) {
          return "Shop name must be at least 3 characters long";
        }
        break;
      case "address":
        if (!input || input.trim().length < 10) {
          return "Address must be at least 10 characters long";
        }
        break;
    }
  };

  return (
    <AppContext.Provider
      value={{
        titleRegTp,
        keywordRegTp,
        categoryRegTp,
        fullNameRegTp,
        messageRegTp,
        emailRegTp,
        passwordRegTp,
        phoneNumberRegTp,
        CNICRegTp,
        dealTitleRegTp,
        descriptionRegTp,
        isLogin,
        user,
        setUser,
        logout,
        authToken,
        regTpChecker,
        setAuthToken,
        setIsLogin,
        setbaseUrlForFiles,
        baseUrlForFiles,
        setbaseUrl,
        baseUrl,
        cartItems,
        addToDealBox,
        selectedCategory,
        selectedCategoryTagline,
        storeSelectedCategory,
        storeSelectedCategoryTagline,
        adminCategory,
        storeAdminCategory,
        selectedScreenOfSellerDashboardSidebar,
        storeSelectedScreenOfSellerDashboardSidebar,
        selectedScreenOfAdminDashboardSidebar,
        storeSelectedScreenOfAdminDashboardSidebar,
        user,
        setUser,
        cart,
        setCart,
        cartCount,
        wishlist,
        setWishlist,
        wishlistCount,
        addToCart,
        loggedInAdmin,
        setLoggedInAdmin,
        logoutAdmin,
        loggedInSeller,
        setLoggedInSeller,
        setLoggedInCustomer,
        loggedInCustomer,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// 4️⃣ Tport AppContext in case you need it directly (optional)
export default AppContext;
